
import { defineComponent, ref, onMounted } from 'vue'
import ListContentLayout from '@/views/layout/ListContentLayout.vue'
import { User } from '@/repositories/data'
import UserUpdateDialog from '@/views/admin/UserUpdateDialog.vue'
import ConfirmDeleteModal from '@/views/modal/ConfirmDeleteModal.vue'
import { callApiWrapper } from '@/views/callApiWrapper'
import ConfirmSendWelcomeMail from '@/views/admin/ConfirmSendWelcomeMail.vue'
import ConfirmSendWelcomeMailAllUser from '@/views/admin/ConfirmSendWelcomeMailAllUser.vue'
import { userRepository } from '@/repositories/admin/userRepository'

export default defineComponent({
  components: {
    ConfirmSendWelcomeMailAllUser,
    ConfirmSendWelcomeMail,
    ConfirmDeleteModal,
    UserUpdateDialog,
    ListContentLayout
  },
  setup () {
    const users = ref<User[]>([])
    const requestError = ref<string | null>(null)
    const showingAddModal = ref<boolean>(false)
    const mailTargetUser = ref<User | null>(null)
    const showingSendAllUser = ref(false)
    const modifyTargetUser = ref<User | null>(null)
    const deleteTargetUser = ref<User | null>(null)

    onMounted(async () => {
      await callApiWrapper(requestError, async () => {
        users.value = await userRepository.list()
      })
    })

    const onUpdated = async () => {
      showingAddModal.value = false
      await callApiWrapper(requestError, async () => {
        users.value = await userRepository.list()
        modifyTargetUser.value = null
      })
    }

    const deleteUser = async (target: User) => {
      await callApiWrapper(requestError, async () => {
        await userRepository.delete(target.key)
        deleteTargetUser.value = null
        users.value = await userRepository.list()
      })
    }

    const updateList = async () => {
      await callApiWrapper(requestError, async () => {
        users.value = await userRepository.list()
      })
    }

    return {
      users,
      showingAddModal,
      modifyTargetUser,
      deleteTargetUser,
      requestError,
      mailTargetUser,
      showingSendAllUser,
      onUpdated,
      deleteUser,
      updateList
    }
  }
})
